import { useEffect, useState } from 'react';

// Standardized Miami HQ date/time indicator. America/New_York (DST-aware), display-only.
// Two variants:
//   default  -> viewport-fixed pill (legacy standalone hubs)
//   inline   -> in-flow block for the sidebar footer, so it occupies its OWN layout
//               space and never overlaps navigation/settings controls (Section 8 fix).
export const MiamiHqFooter = ({ inline = false }) => {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  const time = now.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', timeZone: 'America/New_York' });
  const date = now.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit', timeZone: 'America/New_York' });

  if (inline) {
    return (
      <div
        data-testid="miami-hq-footer"
        className="flex items-center justify-between gap-2 rounded-lg bg-white/5 px-2.5 py-1.5 text-[11px] font-medium text-slate-300"
      >
        <span className="flex items-center gap-1.5">
          <span className="font-semibold text-[#8FC93A]">Miami HQ</span>
          <span className="text-white/30">·</span>
          <span className="whitespace-nowrap">{date}</span>
        </span>
        <span className="whitespace-nowrap font-mono text-slate-200">{time} ET</span>
      </div>
    );
  }

  return (
    <div
      data-testid="miami-hq-footer"
      className="pointer-events-none fixed bottom-3 left-3 z-[60] max-w-[200px] rounded-2xl border border-slate-200 bg-white px-3 py-1.5 text-[11px] font-medium text-slate-500 shadow-md"
    >
      <div className="flex items-center gap-1.5">
        <span className="font-semibold text-[#5FA718]">Miami HQ</span>
        <span className="text-slate-300">·</span>
        <span className="whitespace-nowrap">{date}</span>
      </div>
      <div className="font-mono text-slate-600 whitespace-nowrap">{time} ET</div>
    </div>
  );
};

export default MiamiHqFooter;
